import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class FormValidationComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        LABEL: '[data-validation-label]',
        INPUT: '[data-validation-input]',
        ERROR_INPUT: '.s-hasError',
        ERROR_MESSAGE: '[data-validation-error]',
        SUBMIT: '[data-validation-submit]',
    }

    STATE = {
        ACTIVE: 's-isActive',
        ERROR: 's-hasError',
    }

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {FormValidationComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onSubmitHandler = this.onSubmit.bind(this);

        return this;
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {FormValidationComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$form = this.$element;
        this.$inputs = $(this.SELECTOR.INPUT);
        this.$labels = $(this.SELECTOR.LABEL);
        this.$errorMessages = $(this.SELECTOR.ERROR_MESSAGE);
        this.$submit = this.$element.find(this.SELECTOR.SUBMIT);

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {FormValidationComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {FormValidationComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$form.on('submit', this.onSubmitHandler);

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {FormValidationComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onSubmit(e) {
        if (!this.options.submitOnChange) {
            this.clearErrorStates();
            const shouldSubmit = this.checkInputValidity();

            if (!shouldSubmit) {
                e.preventDefault();
            }
        }
    }

    checkInputValidity() {
        let isValid = true;

        for (const inputToValidate of this.$inputs) {
            const inputValidity = inputToValidate.checkValidity();
            const inputValue = $(inputToValidate).val();

            if (!inputValidity) {
                this.setErrorState(inputToValidate);

                isValid = false;
            }
        }

        return isValid;
    }

    setErrorState(input) {
        const errorInput = $(input);
        const errorToDisplay = errorInput.data('validationInput');
        const errorMessageToDisplay = $('[data-validation-error="' + `${errorToDisplay}` + '"]');

        errorInput.addClass(this.STATE.ERROR);
        errorMessageToDisplay.addClass(this.STATE.ACTIVE);

        this.focusErrorInput();
    }

    focusErrorInput() {
        $(this.SELECTOR.ERROR_INPUT).first()
                                    .focus();
    }

    clearErrorStates() {
        this.$inputs.removeClass(this.STATE.ERROR);
        this.$labels.removeClass(this.STATE.VISUALLY_HIDDEN);
        this.$errorMessages.removeClass(this.STATE.ACTIVE);
    }
}
